export default __webpack_public_path__ + "static/media/female-img.2c14740f.png";